const transactions: Map<string, string> = new Map([
  ['invoice', 'Invoice'],
  ['contractNumber', 'Contract No.'],
  ['purchase', 'Purchase'],
  ['customer', 'Customer'],
  ['amount', 'Amount'],
  ['status', 'Status'],
]);
const purchases: Map<string, string> = new Map([
  ['contractNumber', 'Contract No.'],
  ['invoice', 'RO/Invoice'],
  ['date', 'Date'],
  ['customer', 'Customer'],
  ['purchaseAt', 'Purchase At'],
  ['amount', 'Amount'],
]);
const checkout: Map<string, string> = new Map([
  ['contractNumber', 'Contract No.'],
  ['roInvoice', 'RO/Invoice.'],
  ['date', 'date'],
  ['customer', 'Customer'],
  ['amount', 'Amount'],
  ['invoice', 'Invoice'],
]);
const declineKeys: Map<string, string> = new Map([
  ['creationTime', 'Date'],
  ['retailerName', 'Retailer Name'],
  ['amount', 'Amount'],
  ['phoneNumber', 'Customer Phone Number'],
  ['zipCode', 'Zip Code'],
  ['declineKey', 'Decline Key'],
]);

const titlesList = {
  partnersPortals: {
    transactions,
    purchases,
    checkout,
    declineKeys,
  },
};

export default titlesList;
